import RecordTaxPaymentTask from 'modules/Tasks/SubmitActions/customComponents/RecordTaxPaymentTask';
import { QTEType } from 'modules/Tax/types';
import { SubmitActionTask } from 'modules/Tasks/types';

interface RecordFeesAndFranchiseTaxPaymentTaskProps {
    open: boolean;
    onClose: () => void;
    task: SubmitActionTask;
}

/**
 * `record_fees_and_franchise_tax_payment` — the record-it-yourself child of the fees and franchise
 * taxes card (CA franchise, DC corporate franchise, IL replacement, NYC GCT). BUSINESS is load
 * bearing: it makes the modal derive payment_type "business", which is what the Fees and Franchise
 * history filters on and what the backend settles this card on. FEDERAL or STATE here would record
 * the payment as a quarterly estimate and it would vanish from that history.
 */
export default function RecordFeesAndFranchiseTaxPaymentTask({
    open,
    onClose,
    task,
}: Readonly<RecordFeesAndFranchiseTaxPaymentTaskProps>) {
    return <RecordTaxPaymentTask open={open} onClose={onClose} task={task} taxType={QTEType.BUSINESS} />;
}
